<template>
<div class="height-video-fluid">
    <div ref="fluid"></div>
    <transition enter-active-class="animated fadeInUp">
        <div id="bg-image" v-if="showObserver"
        class="d-flex justify-content-center align-items-center height-700 background-image"
        :style="`background-position: center; background-image: url(${data.imagem.url})`">
            <div class="btn-play" @click="showVideo"></div>

            <b-modal 
                @show="play = true"
                @hide="play = false" 
                ref="modal"
                body-class="p-0" 
                size="lg" 
                hide-footer 
                hide-header  
                centered 
                title="Using Component Methods"
            >
                <iframe width="100%" height="400px" :src="`https://www.youtube.com/embed/${data.id}?&autoplay=1`" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen v-if="play"></iframe>
            </b-modal>
        </div>
    </transition>
</div>

</template>


<script>
    import observer from 'intersection-observer';

    export default {
        props:{
            data: null
        },

        data(){
            return {
                play: false,
                show: false,

                showObserver: false,
            }
        },

        mounted(){
            var observer = new IntersectionObserver((entries) => {
                // If intersectionRatio is 0, the target is out of view
                // and we do not need to do anything.
                if (entries[0].intersectionRatio <= 0) {
                    return;
                }
                // this.loadPosts()
                this.showObserver = true
                observer.unobserve(this.$refs.fluid)

            });
            observer.POLL_INTERVAL = 100;
            observer.observe(this.$refs.fluid)
        },

        methods:{
            showVideo(){
                this.$refs.modal.show()
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/video_fluid.vue